<template>
    <footer>
        <div>
            <span class="mr-1">
                {{ $t(`org.footer.${VUE_APP_NAMESPACE}.MEGAZONE`) }}
            </span>
            <span class="mr-1">
                {{ $t(`org.footer.${VUE_APP_NAMESPACE}.Business Registration No`) }}
            </span>
            <span class="mr-1">
                {{ $t(`org.footer.${VUE_APP_NAMESPACE}.CEO`) }}
            </span>
            <a
                class="mr-1"
                :href="`${VUE_APP_AUTH_CENTER_URL}/privacy?locale=${locale}&theme=${skin}`"
                target="_blank"
                style="vertical-align:text-bottom"
            >
                {{ $t(`org.footer.${VUE_APP_NAMESPACE}.Privacy Notice`) }}
            </a>
            <a
                href="https://privacy.megazone.com/production/mzc/cctv/index.html"
                target="_blank"
                style="vertical-align:text-bottom"
            >
                {{ $t(`org.footer.${VUE_APP_NAMESPACE}.CCTV Notice`) }}
            </a>
        </div>
        <div>
            <span class="mr-1">
                {{ $t(`org.footer.${VUE_APP_NAMESPACE}.MEGAZONE B/D, 46, Nonhyeon-ro 85-gil, Gangnam-gu, Seoul,
                South Korea`) }}
            </span>
            <span class="mr-1">
                {{ $t(`org.footer.${VUE_APP_NAMESPACE}.Contact Call`) }}
            </span>
            <span>
                {{ $t(`org.footer.${VUE_APP_NAMESPACE}.Contact Email`) }}
            </span>
        </div>
        <div>
            <span style="font-style:italic">
                {{ $t(`org.footer.${VUE_APP_NAMESPACE}.Copyright`) }}
            </span>
        </div>
    </footer>
</template>
<script>
import useAppConfig from '@core/app-config/useAppConfig'
import useEnvString from '@/composables/useEnvString'
import { ref } from '@vue/composition-api'
export default {
    setup () {
        const { skin } = useAppConfig()
        const {
            VUE_APP_NAMESPACE,
            VUE_APP_AUTH_CENTER_URL
        } = useEnvString()
        const locale = ref(localStorage.getItem('locale'))
        return {
            VUE_APP_NAMESPACE,
            VUE_APP_AUTH_CENTER_URL,
            skin,
            locale
        }
    }
}
</script>
<style scoped>
/** FOOTER */
footer {
    width: 100%;
    padding: 1rem;
    border-top: 1px solid rgba(34, 41, 47, 0.125);
    z-index: 2;
    text-align: center;
    background-color: #fff;
    position: fixed;
    bottom: 0;
    color: #5e5873;
}
</style>
